import {Inject, Injectable, LOCALE_ID} from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import {AuthService} from './auth.service';
import {Observable, of} from 'rxjs';
import {catchError, map, tap} from 'rxjs/operators';
import {Router} from '@angular/router';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {

  constructor(
    private auth: AuthService,
    @Inject(LOCALE_ID) private locale: string,
    private router: Router
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (!this.auth.accessToken) {
      return next.handle(req);
    }

    const newRequest = req.clone({
      headers: req.headers.append('AISAuth', this.auth.accessToken),
      params: req.params.append('lng', this.locale.substr(0, 2).toUpperCase())
    });

    return next.handle(newRequest)
      .pipe(

        catchError((error: any) => {

          if (error instanceof HttpErrorResponse) {
            if (error.status === 401) {
              this.router.navigate(['/auth-error']).then(r => {});
            }
            if (error.status === 500) {
              console.log(error);
            }
          }

          throw error;
        })
      );
  }

}
